import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "font-awesome/css/font-awesome.min.css";
import "../css/main.css";
import logo from '../assets/logo.png';
import { faBell,faEye,faListCheck,faFolderOpen,faCalendar,faComment } from "@fortawesome/free-solid-svg-icons";
import Breadcrumb from "./Breadcrumb";

export default function UserNav() {
  const [user, setUser] = useState(null);
  const [isTaskRunning, setIsTaskRunning] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const originalTitleRef = useRef(document.title);

  useEffect(() => {
    axios
      .get("/api/mainuser.php?action=dashboard", {
        withCredentials: true,
      })
      .then((res) => setUser(res.data.user))
      .catch(() => (window.location.href = "/userlogin"));
  }, []);

  useEffect(() => {
    if (!user) return;
    const fetchTasks = () => {
      axios
        .get("/api/mainuser.php?action=tasks", {
          withCredentials: true,
        })
        .then((res) => {
          const tasks = res.data || [];
          let foundRunning = false;
          for (const task of tasks) {
            try {
              const sessions = JSON.parse(task.duration || "[]");
              const last = sessions[sessions.length - 1];
              if (last?.start && !last?.pause && !last?.end) {
                foundRunning = true;
                break;
              }
            } catch {}
          }
          setIsTaskRunning(foundRunning);
        });
    };
    fetchTasks();
    const pollInterval = setInterval(fetchTasks, 1000);
    return () => clearInterval(pollInterval);
  }, [user]);

  useEffect(() => {
    let intervalId;
    let show = true;
    const cleanTitle = (title) => title.replace(/●/g, "").trim();
    if (isTaskRunning) {
      intervalId = setInterval(() => {
        const baseTitle = cleanTitle(originalTitleRef.current);
        document.title = show ? `● ${baseTitle}` : ` ${baseTitle}`;
        show = !show;
      }, 1000);
    } else {
      document.title = cleanTitle(originalTitleRef.current);
    }
    return () => clearInterval(intervalId);
  }, [isTaskRunning]);

 useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await axios.get("/api/notifications.php", {
          withCredentials: true,
        });
        setNotifications(res.data || []);
      } catch (err) {
        console.error("Failed to fetch notifications:", err);
        setNotifications([{ message: "Failed to load notifications." }]);
      }
    };

    fetchNotifications();
  }, []);

  // 🔘 Toggle popup and optionally refresh
  const toggleNotifications = async () => {
    if (!showPopup) {
      try {
        const res = await axios.get("/api/notifications.php", {
          withCredentials: true,
        });
        setNotifications(res.data || []);
        setSelected([]);
      } catch (err) {
        console.error("Failed to fetch notifications:", err);
        setNotifications([{ message: "Failed to load notifications." }]);
      }
    }
    setShowPopup(!showPopup);
  };

  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const deleteSelectedNotifications = async () => {
    try {
      await axios.post(
        "/api/delete_notifications.php",
        { ids: selected },
        { withCredentials: true }
      );
      setNotifications((prev) => prev.filter((item) => !selected.includes(item.id)));
      setSelected([]);
    } catch (error) {
      console.error("Failed to delete notifications:", error);
    }
  };


  return (
    <nav className="bg-white shadow-2xl px-6  flex items-center justify-between">
      <div className="flex gap-3">
          <img src={logo} alt="Logo" className="w-18 h-14 object-contain" />
          <Breadcrumb />
        </div>
      <div className="flex  justify-between items-center space-x-4">
        
        <div className="bg-blue-100 text-blue-700 font-medium text-sm px-3 py-1 rounded-full">
          {user?.username || "Loading..."}
        </div>
      </div>

        {notifications.length > 0 && (
        <button
    className="fixed bottom-7 right-5 bg-gray-800 hover:bg-gray-200 hover:text-gray-800 text-white px-3 py-2 rounded-full shadow-lg z-50 glow-button"
    onClick={toggleNotifications}
  >
    <FontAwesomeIcon icon={faBell} />
    <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
      {notifications.length}
    </span>
  </button>
        )}

  

  


      {/* Notification Popup */}
      {showPopup && notifications.length > 0 && (
        <div className="fixed bottom-20 right-10 bg-white shadow-xl rounded-lg border border-gray-200 p-5 w-80 z-50 animate-fade-in max-h-74 overflow-y-auto scrollbar-hide">
          <div className="flex justify-between items-center mb-3">
            <p className="text-gray-700 font-semibold">🔔 Notifications</p>
            {selected.length > 0 && (
              <button
                className="text-gray-500 hover:text-red-700 text-sm bg-gray-100 font-semibold px-3 rounded-sm shadow-xl"
                onClick={deleteSelectedNotifications}
              >
                <FontAwesomeIcon icon={faEye} className="text-xs"/> View
              </button>
            )}
          </div>
          {notifications.length === 0 ? (
            <p className="text-sm text-gray-700">You have no new notifications.</p>
          ) : (
            <ul className="text-sm text-gray-700 space-y-3 mt-2">
              {notifications.map((item) => (
                <li
                  key={item.id}
                  className={`flex items-center gap-2 px-3 py-2 rounded mt-1 ${
                    item.type_of === 'Done Task' ? 'bg-green-100' : 'bg-gray-100'
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={selected.includes(item.id)}
                    onChange={() => handleSelect(item.id)}
                    className="mb-auto mt-1"
                  />
                  <div>
                    <p className="font-semibold text-gray-700 flex">
                      {item.type_of === 'task' ? (
                        <p className="font-semibold text-gray-700 ">
                          {item.type_of === 'task' ? 'New Task ' : 'New Project'}{" "}
                            
                        </p>
                        ) : item.type_of === 'project' ? (
                        <>
                          New Project  
                        </>
                      ) : item.type_of === 'Done Task' ? (
                        <>
                          Task Done  
                        </>
                      ) : item.type_of === 'Comment' ? (
                        <>
                          Comment  
                        </>
                      ) : (
                        ''
                      )}
                      
                      <span className="text-[11px] pt-1">
                        {item.type_of === 'Done Task' ? (
                        <span>,Assign To @{item.user}</span>
                      ) : item.type_of === 'Comment' ? (
                        <>
                          
                        </>
                      ) : (
                        <span>,Assign By @{item.assign_by}</span>
                      )}
                         </span>
                    </p>
                    <p className="mt-1">
                      {item.type_of === 'task' || item.type_of === 'Done Task' ? (
                        <FontAwesomeIcon icon={faListCheck} className="mr-2 text-blue-500" />
                      ) : item.type_of === 'Comment' ? (
                        <FontAwesomeIcon icon={faComment} className="mr-1 text-yellow-500" />
                      ) : (
                        <FontAwesomeIcon icon={faFolderOpen} className="mr-2 text-yellow-500" />
                      )}
                      {item.type_of === 'Comment' ? (() => {
                        const parts = item.name?.split('--');
                        const message = parts?.[0]?.trim();
                        const details = parts?.[1]?.split(',') || [];
                        const date = details?.[0]?.trim();
                        const time = details?.[1]?.trim();
                        const user = details?.[2]?.trim();
                        
                        return (
                          <span>
                            <span className="font-semibold text-gray-800">{message}</span>{' '}<br />
                            <span className="text-[10px] text-gray-500 ml-auto">{date}, {time} by @{user}</span>
                          </span>
                        );
                      })() : (
                        item.name || "🔔 Notification"
                      )}
                    </p>
                    <p className=""><span className="text-xs">
                    {item.type_of === 'Comment' ? (
                      <p>Task Name: {item.project_id}</p>
                    ) : (
                      item.project_id ? (
                        <p>
                          <span className="text-[11px] ml-5">(Project Id : {item.project_id})</span>
                        </p>
                      ) : (
                        <span className="bg-white shadow-xl px-2 py-[1px] ml-5 rounded-sm">Single Task</span>
                      )
                    )}
                    </span></p>
                    {item.type_of === 'Comment' ? (
                      <p></p>
                      ) : (
                        <p className="text-[11px] text-right pl-29 mt-2">
                      <FontAwesomeIcon icon={faCalendar} />{" "}
                      {item.timestamp
                        ? new Date(item.timestamp).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          }).replace(",", "")
                        : "No Date"}
                    </p>
                      )}

                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </nav>
  );
}
